var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"math-render"},[_c('span',{staticClass:"mathview",attrs:{"id":_vm.mathview}}),(_vm.imgshow && !_vm.value)?_c('img',{attrs:{"src":_vm.img.penicon}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }